export default __webpack_public_path__ + "static/media/boat.aff5a9c9.ogg";